import React from 'react';
import { Mail, MapPin, Phone, Trash2 } from 'lucide-react';
interface FooterProps {
  onReserve: () => void;
}
export function Footer({
  onReserve
}: FooterProps) {
  return <footer className="w-full border-t border-border bg-card" data-id="element-178">
      <div className="container py-12" data-id="element-179">
        <div className="grid gap-8 md:grid-cols-4" data-id="element-180">
          <div className="md:col-span-2" data-id="element-181">
            <div className="flex items-center gap-2" data-id="element-182">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary text-primary-foreground" data-id="element-183">
                <Trash2 className="h-5 w-5" data-id="element-184" />
              </span>
              <span className="text-base font-semibold" data-id="element-185">
                Greeneway Solutions
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm text-muted-foreground" data-id="element-186">
              Straightforward dumpster rentals for homeowners and contractors
              across your area and the greater metro area.
            </p>
            <p className="mt-3 text-sm text-muted-foreground" data-id="element-187">
              Want to talk through your project?{' '}
              <a className="font-medium text-primary hover:underline" href="tel:+15551234567" data-id="element-188">
                Schedule a quick consultation
              </a>
              .
            </p>
          </div>

          <div data-id="element-189">
            <h4 className="text-sm font-semibold text-foreground" data-id="element-190">Company</h4>
            <ul className="mt-4 space-y-2 text-sm text-muted-foreground" data-id="element-191">
              <li data-id="element-192">
                <a href="#sizes" className="hover:text-foreground" data-id="element-193">
                  Sizes & Pricing
                </a>
              </li>
              <li data-id="element-194">
                <a href="#service-areas" className="hover:text-foreground" data-id="element-195">
                  Service Areas
                </a>
              </li>
              <li data-id="element-196">
                <a href="#materials" className="hover:text-foreground" data-id="element-197">
                  Accepted Materials
                </a>
              </li>
              <li data-id="element-198">
                <a href="#how-it-works" className="hover:text-foreground" data-id="element-199">
                  How It Works
                </a>
              </li>
              <li data-id="element-200">
                <a href="#faq" className="hover:text-foreground" data-id="element-201">
                  FAQ
                </a>
              </li>
              <li data-id="element-202">
                <button type="button" onClick={onReserve} className="hover:text-foreground" data-id="element-203">
                  Reserve online
                </button>
              </li>
            </ul>
          </div>

          <div data-id="element-204">
            <h4 className="text-sm font-semibold text-foreground" data-id="element-205">Contact</h4>
            <ul className="mt-4 space-y-3 text-sm text-muted-foreground" data-id="element-206">
              <li className="flex items-center gap-2" data-id="element-207">
                <Phone className="h-4 w-4 text-primary" data-id="element-208" />
                <a href="tel:+15551234567" className="hover:text-foreground" data-id="element-209">
                  (555) 123-4567
                </a>
              </li>
              <li className="flex items-center gap-2" data-id="element-210">
                <Mail className="h-4 w-4 text-primary" data-id="element-211" />
                <a href="mailto:hello@greeneway.com" className="hover:text-foreground" data-id="element-212">
                  hello@greeneway.com
                </a>
              </li>
              <li className="flex items-start gap-2" data-id="element-213">
                <MapPin className="mt-0.5 h-4 w-4 text-primary" data-id="element-214" />
                Serving the greater metro area
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-2 border-t border-border pt-6 text-sm text-muted-foreground sm:flex-row" data-id="element-215">
          <p data-id="element-216">
            © {new Date().getFullYear()} Greeneway Solutions. All rights
            reserved.
          </p>
          <p data-id="element-217">Licensed & insured local haulers.</p>
        </div>
      </div>
    </footer>;
}